import ShortlistComponent from '../../Components/ShortlistComponent/ShortlistComponent';

const ShortlistPage = (props) => {
  return (
    <div style={{ marginBottom: '2px' }}>
      <ShortlistComponent pdfDownloadClick={props.pdfButtonClick} />
    </div>
  );
};

export default ShortlistPage;
